export const GstSlabs = ({ title, items, type }) => (
  <>
    <tr>
      {/* <td colSpan="5" className="gst-slab">
        {title}
      </td> */}
    </tr>
    {items?.map((item, index) => (
      <tr key={index}>
        <td className="order-item-list-box">{item?.hsnCode?.substring(0, 4)}</td>
        {/* <td className="order-item-list-box">
          {localStorage.getItem("retailType") === "RESTAURANT"
            ? `${item?.productName} (${item?.variantName}) ${
                item?.status === "RETURNED" ? (
                  <span
                    className={`order-item-list-box ${
                      item?.status === "RETURNED" ? "orderReturnedItems" : ""
                    }`}
                  >
                    {"Returned"}
                  </span>
                ) : (
                  ""
                )
              }`
            : item?.productName}{" "}
          <br />
          {item?.addonProduct?.length > 0 && (
            <span>
              {`Add Ons: (${item?.addonProduct?.map((addOn) => addOn?.itemName).join(", ")})`}
            </span>
          )}
        </td> */}
        <td className="order-item-list-box">
          {localStorage.getItem("retailType") === "RESTAURANT" ? (
            <>
              {item?.productName} ({item?.variantName})
              {item?.status === "RETURNED" && (
                <span className="orderReturnedItems"> {`(Returned)`}</span>
              )}
              {item?.inventoryStatus === "COMPLEMENTARY" && (
                <span className="orderCompItems"> {`(Complementary)`}</span>
              )}
            </>
          ) : (
            item?.productName
          )}

          <br />

          {item?.addonProduct?.length > 0 && (
            <span>Add Ons: ({item?.addonProduct?.map((addOn) => addOn?.itemName).join(", ")})</span>
          )}
        </td>

        <td className="order-item-list-box">
          {type === "returns" ? item?.returnedQuantity : item?.quantityBySpecs}
        </td>
        <td className="order-item-list-box">₹ {item?.sellingPrice}</td>
        <td className="order-item-list-box">
          ₹ {type === "returns" ? item?.returnedSubTotal : item?.subTotal}
        </td>
      </tr>
    ))}
  </>
);
